<template>
  <div class="container container-fluid card my-4">

    <div v-if="mostrarForm">
      <div class="text-left pt-4 mx-2">
        <h5>EMPRESAS</h5>
      </div>
    </div>
    <!--  SPINERS CARGA TABLA -->
    <div v-if="loadingComponent" class="spinner-container container-fluid">
      <Loading-Style/>
    </div>
    <!-- TABLA -->
    <transition name="slide-fade">
      <div v-if="!loadingComponent">
        <div v-if="mostrarTabla" id="content">
          <TableComponent 
          :dataDATA="responseDATA"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import apiAdmin from "../../../apis/Admin";
import TableComponent from "./TableCompanies";
import { handleSweetInfo } from "../../../Utils/StatusHandler";

export default {
  name: "ArmaEntregaListIndex",
  components: {
    TableComponent,
  },
  setup() {
    const loadingComponent = ref(false);
    const mostrarForm = ref(true);
    const response = ref(null);
    const mostrarTabla = ref(true);

    const responseDATA = ref(null);

    const errors = ref([]);
    const alert = ref([]);

    const handleSweetAlert = (info) => {
      handleSweetInfo(info, { alert });
    };

    const fetchCompanies = async () => {
      try {

        const response = await apiAdmin.getCompanies();
        
        if (response) {
          const resultadosDATA = response.data;

          if (resultadosDATA.length > 0) {

            responseDATA.value = resultadosDATA;
            return resultadosDATA;
          } else if (resultadosDATA.length === 0) {
            handleSweetAlert(response);
          } else {
            handleSweetAlert(response);
          }
        }
      } catch (error) {
        console.error(error);
        handleSweetAlert(error);
      } finally {
        loadingComponent.value = false;
      }
    };

    const formsList = () => {

      loadingComponent.value = true;

      fetchCompanies().then((companies) => {
        if (companies) {
          response.value = companies;
          loadingComponent.value = false;
        }
      });
    };

    onMounted( () => {
      formsList();
    });

    return {
      loadingComponent,
      mostrarForm,
      response,
      mostrarTabla,
      responseDATA,
      errors,
      alert,
    };
  },
};
</script>
